import { createFileRoute } from '@tanstack/react-router';
import { CardFormPage } from '../../../sheets/cards/CardFormPage.js';
import { validateCardSearch } from '../../../sheets/cards/href.js';

/** `/sheets/cards/$docId` (2.M): the spell or item card form of one page. */
export const Route = createFileRoute('/sheets/cards/$docId')({
  validateSearch: validateCardSearch,
  component: CardFormRoute,
});

function CardFormRoute(): React.JSX.Element {
  const { docId } = Route.useParams();
  const { compare } = Route.useSearch();
  return (
    <main className="cx-cards-page">
      <CardFormPage docId={docId} compare={compare === 1} />
    </main>
  );
}
